var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app", attrs: { id: "app" } },
    [
      _vm.isBrowserSupport && _vm.isWebGlSupport
        ? [
            _c(
              "keep-alive",
              { attrs: { exclude: ["conference", "login"] } },
              [_c("router-view")],
              1
            ),
          ]
        : [
            _c("div", { staticClass: "full-center error-wrapper" }, [
              !_vm.isBrowserSupport
                ? _c("div", [
                    _c("figure", { staticClass: "error-wrapper-container" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.noSupportedImage,
                          alt: "browser no support",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("browserNoSupport")),
                        },
                      }),
                    ]),
                  ])
                : !_vm.isWebGlSupport
                ? _c("div", [
                    _c("figure", { staticClass: "error-wrapper-container" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.noSupportedImage,
                          alt: "webgl no support",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("webGlNoSupport")),
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ],
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "modal", multiple: "" } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }